import React from "react";

import { Button, Alert } from "@partials";
import { AlertType } from "@constants";
import { getLocalization } from "@utilities";
import { usePagination } from "@hooks";

import { TransparentAccountListType as Props } from "./types";
import { SEARCH_FORM_CLASSNAME } from "./constants";
import { ItemsList } from "./components";

const TransparentAccountList: React.FC<Props> = ({
  api,
  query,
  baseUrl,
  items: defaultItems,
  pagination: defaultPagination,
  localization,
  cultureCode,
}) => {
  const { hasNextItems, isLoadingMore, items, loadNextItems, hasError } = usePagination({
    api,
    defaultQuery: query,
    formElement: document.querySelector(`.${SEARCH_FORM_CLASSNAME}`),
    formInputName: "query",
    fetchBodyData: { baseUrl },
    defaultItems,
    defaultPagination,
    cultureCode,
  });

  const hasNoItems = !items?.length;

  return (
    <div className="sm:col-14 sm:offset-1">
      {(hasError || hasNoItems) && (
        <div className={`${hasNoItems ? "mb-0" : "mb-8"}`}>
          <Alert
            type={AlertType.Error}
            text={getLocalization(localization, "transparentAccountList/errorMessage")}
            textAttributes={{ role: "alert", "aria-live": "assertive" }}
          />
        </div>
      )}

      <ItemsList items={items} />

      {hasNextItems && (
        <Button
          template="secondary"
          title={getLocalization(localization, "transparentAccountList/button")}
          type="button"
          isLoading={isLoadingMore}
          onClick={loadNextItems}
          dataTestId="button-load-more"
        />
      )}
    </div>
  );
};

export default TransparentAccountList;
